'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../button');

var _button2 = _interopRequireDefault(_button);

var _XIcon = require('../../../icons/XIcon');

var _unsavedChangesModal = require('../unsaved-changes-modal');

var _unsavedChangesModal2 = _interopRequireDefault(_unsavedChangesModal);

var _modalContext = require('../../../context/modal-context');

var _scrollArea = require('../../scroll-area/scroll-area');

var _scrollArea2 = _interopRequireDefault(_scrollArea);

require('./modal-overlay.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var STYLE_BASE = 'zk-modal-overlay_';

var ModalOverlay = function ModalOverlay(_ref) {
  var hideCloseButton = _ref.hideCloseButton,
      noScrollArea = _ref.noScrollArea,
      wrapperClassName = _ref.wrapperClassName;
  return _react2.default.createElement(_modalContext.ModalConsumer, null, function (_ref2) {
    var _classNames;

    var modalComponent = _ref2.modalComponent,
        overlayStyle = _ref2.overlayStyle,
        clearModal = _ref2.clearModal,
        handleOutsideClick = _ref2.handleOutsideClick,
        isDisplayingUnsavedModal = _ref2.isDisplayingUnsavedModal,
        skipLayout = _ref2.skipLayout,
        className = _ref2.className,
        startRef = _ref2.startRef;

    if (!modalComponent) {
      return;
    }

    var WrapperComponent = noScrollArea ? 'div' : _scrollArea2.default;
    var wrapperProps = noScrollArea ? {
      className: STYLE_BASE + 'scrollView'
    } : {
      className: STYLE_BASE + 'modal-wrapper ' + STYLE_BASE + 'modalContainer',
      contentContainerStyle: {
        alignItems: 'center',
        marginTop: 37,
        marginBottom: 40
      },
      scrollEnabled: !isDisplayingUnsavedModal
    };
    return _react2.default.createElement('div', {
      'data-testid': 'OVERLAY_MODAL_WRAPPER',
      style: overlayStyle,
      className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, STYLE_BASE + 'overlay', true), _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, STYLE_BASE + 'opened', !!modalComponent), _defineProperty(_classNames, wrapperClassName, !!wrapperClassName), _classNames)),
      onMouseDown: handleOutsideClick
    }, skipLayout ? modalComponent : _react2.default.createElement(_react.Fragment, null, isDisplayingUnsavedModal && _react2.default.createElement(_unsavedChangesModal2.default, null), _react2.default.createElement(WrapperComponent, _extends({
      'data-testid': 'OVERLAY_MODAL_SCROLL'
    }, wrapperProps), _react2.default.createElement('div', {
      className: STYLE_BASE + 'container',
      onMouseDown: function onMouseDown(e) {
        return e.stopPropagation();
      }
    }, !hideCloseButton && _react2.default.createElement(_button2.default, {
      className: STYLE_BASE + 'closeBtn',
      'data-testid': 'OVERLAY_MODAL_CLOSE',
      onClick: clearModal,
      ref: startRef,
      transparent: true
    }, _react2.default.createElement(_XIcon.XIcon, {
      className: STYLE_BASE + 'closeIcon',
      color: '#FFF'
    })), _react2.default.createElement('div', {
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, modalComponent)))));
  });
};

exports.default = ModalOverlay;